import React, { useState, useEffect, useRef } from 'react';
import { Form, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { getAdminSettings, getBaseURL } from '../api/api';
import axios from 'axios';
import Dropdown from './Dropdown';
import { schools, grades } from '../../data/Data';
import FormGroup from './FormGroup';
import ValidationError from './ValidationError';
import TextField from '@mui/material/TextField';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import style from '../css/Student.module.css';

const Student = (props) => {
  const {
    counter,
    onChange,
    hasDOB,
    onSchoolChange,
    studentValidated,
    adddate
  } = props;

  //           ---------Minimum Date Limit-----------

  const minDate = new Date(
    new Date().getFullYear() - 22,
    new Date().getMonth(),
    new Date().getDate()
  );
  // .toISOString()
  // .split("T")[0];

  //           ---------Maximum Date Limit-----------

  const maxDate = new Date(
    new Date().getFullYear() - 4,
    new Date().getMonth(),
    new Date().getDate()
  );
  // .toISOString()
  // .split("T")[0];

  const [adminYear, setAdminYear] = useState('');
  const [gradeOptions, setGradeOptions] = useState([]);
  const [fNameValidated, setFNameValidated] = useState(true);
  const [mNameValidated, setMNameValidated] = useState(true);
  const [lNameValidated, setLNameValidated] = useState(true);
  const [dateValidated, setDateValidated] = useState(true);
  const [date, setDate] = useState('');
  const [schoolList, setSchoolList] = useState([]);
  const [grade, setGrade] = useState('');
  const [datePickerValue, setdatePickerValue] = useState('');
  const dateInputContainerRef = useRef(null);
  let adminSettings;

  //          ---------- Datepicker Handler ------------------

  const handleDateChange = (selectedDate) => {
    if (selectedDate) {
      try {
        // Format the date as YYYY-MM-DD for backend
        const year = selectedDate.getFullYear();
        const month = (selectedDate.getMonth() + 1).toString().padStart(2, '0');
        const day = selectedDate.getDate().toString().padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        
        setDate(formattedDate);
        setdatePickerValue(selectedDate);
        adddate(counter, formattedDate);
        
        // Validate the date
        if (selectedDate >= minDate && selectedDate <= maxDate) {
          setDateValidated(true);
        } else {
          setDateValidated(false);
        }
      } catch (error) {
        console.error('Date parsing error:', error);
        setDateValidated(false);
      }
    } else {
      // Empty input
      setDateValidated(false);
    }
  };

  useEffect(async () => {
    const res = await axios.get(`${getBaseURL()}/schools`);
    setSchoolList(res.data);
    // console.log('res', res.data);
  }, []);

  useEffect(async () => {
    await getAdminSettings().then((res) => {
      adminSettings = res;
      setAdminYear(
        `${+adminSettings?.adminYear}-${+adminSettings?.adminYear + 1}`
      );
    });
    if (fNameValidated && mNameValidated && lNameValidated && dateValidated) {
      studentValidated(true);
    } else {
      studentValidated(false);
    }
  }, [fNameValidated, mNameValidated, lNameValidated, dateValidated]);

  const fNameValidate = (e) => {
    const nameRegEx = /^[A-Za-z][A-Za-z\'\-]+([\ A-Za-z][A-Za-z\'\-]+)*$/;
    e.target.value.length > 0
      ? nameRegEx.test(e.target.value)
        ? setFNameValidated(true)
        : setFNameValidated(false)
      : setFNameValidated(true);
  };
  const mNameValidate = (e) => {
    const nameRegEx = /^[A-Za-z\'\-]+([\ A-Za-z][A-Za-z\'\-]+)*$/;
    e.target.value.length > 0
      ? nameRegEx.test(e.target.value)
        ? setMNameValidated(true)
        : setMNameValidated(false)
      : setMNameValidated(true);
  };
  const lNameValidate = (e) => {
    const nameRegEx = /^[A-Za-z][A-Za-z\'\-]+([\ A-Za-z][A-Za-z\'\-]+)*$/;
    e.target.value.length > 0
      ? nameRegEx.test(e.target.value)
        ? setLNameValidated(true)
        : setLNameValidated(false)
      : setLNameValidated(true);
  };

  const dateValidate = (selectedDate) => {
    if (selectedDate) {
      if (selectedDate >= minDate && selectedDate <= maxDate) {
        setDateValidated(true);
      } else {
        setDateValidated(false);
      }
    } else {
      setDateValidated(false);
    }
  };

  /** Parse typed MM/dd/yyyy (or M/d/yyyy) to avoid react-datepicker misparsing year as 2020 */
  const parseTypedDate = (raw) => {
    if (!raw || typeof raw !== 'string') return null;
    const trimmed = raw.trim();
    const match = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (!match) return null;
    const [, month, day, year] = match;
    const m = parseInt(month, 10);
    const d = parseInt(day, 10);
    const y = parseInt(year, 10);
    if (m < 1 || m > 12 || d < 1 || d > 31) return null;
    const date = new Date(y, m - 1, d);
    if (date.getFullYear() !== y || date.getMonth() !== m - 1 || date.getDate() !== d) return null;
    return date;
  };

  const handleDateBlur = (e) => {
    const raw = e?.target?.value ?? dateInputContainerRef.current?.querySelector?.('input')?.value;
    if (raw) {
      const parsed = parseTypedDate(raw);
      if (parsed) {
        handleDateChange(parsed);
        return;
      }
    }
    dateValidate(datePickerValue);
  };

  // FIXME there is a bug when you do back and forth between school and grade dropdowns
  const handleSchoolDropdown = (event) => {
    const newGradeOptions = grades.filter(
      (g) => g.level === event.target.value
    );
    setGradeOptions(newGradeOptions);
    onChange(event);
    onSchoolChange && onSchoolChange();
  };

  const gradeHandler = (event) => {
    setGrade(event.target.value);
    onChange(event);
  };
  return (
    <div>
      <div className={`p-2 ${style.title}`}>
        {counter != 0 ? 'Sibling ' + counter + ' - ' : ''}Student Information
      </div>
      <div className={`p-3  ${style.student} `}>
        <Form.Row
          counter={counter}
          className={`justify-content-between flex-nowrap m-auto ${style.row}`}
        >
          <Col counter={counter}>
            <FormGroup
              id="fname"
              type="text"
              onChange={onChange}
              label="First Name"
              placeholder=""
              onBlur={fNameValidate}
              required={true}
            />
            {!fNameValidated && <ValidationError field="First Name" />}
          </Col>
          <Col counter={counter}>
            <FormGroup
              id="mname"
              type="text"
              onChange={onChange}
              label="Middle Name (optional)"
              required={false}
              onBlur={mNameValidate}
            />
            {!mNameValidated && <ValidationError field="Middle Name" />}
          </Col>

          <Col counter={counter}>
            <FormGroup
              id="lname"
              type="text"
              onChange={onChange}
              label="Last Name"
              placeholder=""
              onBlur={lNameValidate}
            />
            {!lNameValidated && <ValidationError field="Last Name" />}
          </Col>
        </Form.Row>
        <Form.Row
          counter={counter}
          className={`justify-content-between flex-nowrap m-auto ${style.row}`}
        >
          {hasDOB ? (
            <Col counter={counter}>
              <Col>
                <Form.Label>Date of birth</Form.Label>
                <div className={style.datePickerContainer} ref={dateInputContainerRef}>
                  <DatePicker
                    id="birthDate"
                    selected={datePickerValue}
                    onChange={handleDateChange}
                    onBlur={handleDateBlur}
                    minDate={minDate}
                    maxDate={maxDate}
                    placeholderText="MM/DD/YYYY"
                    dateFormat="MM/dd/yyyy"
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    className={`form-control ${!dateValidated ? 'is-invalid' : ''}`}
                    required
                    popperPlacement="bottom-start"
                    popperClassName={style.datePickerPopper}
                    popperModifiers={[
                      {
                        name: 'preventOverflow',
                        options: {
                          enabled: true,
                          boundariesElement: 'viewport'
                        }
                      },
                      {
                        name: 'offset',
                        options: {
                          offset: [0, 5]
                        }
                      },
                      {
                        name: 'flip',
                        options: {
                          enabled: true,
                          fallbackPlacements: ['top-start']
                        }
                      }
                    ]}
                  />
                </div>
                {!dateValidated && <ValidationError field="Date" />}
              </Col>
            </Col>
          ) : (
            <></>
          )}
          <Col counter={counter}>
            <Dropdown
              id="school"
              // value={school}
              onChange={handleSchoolDropdown}
              label={`School (${adminYear})`}
              defaultVal="School"
              options={schoolList}
            />
          </Col>
          <Col counter={counter}>
            <Dropdown
              id="grade"
              onChange={gradeHandler}
              label={`Grade (${adminYear})`}
              value={grade}
              defaultVal="Grade"
              options={gradeOptions}
            />
          </Col>
        </Form.Row>
      </div>
    </div>
  );
};
Student.defaultProps = {
  hasDOB: true
};
Student.propTypes = {
  counter: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  hasDOB: PropTypes.bool
};
export default Student;
